export function getRootNameList() {
    const rootNameList = [
        'ADP',
        'Non ADP',
    ];
    return rootNameList;
}

export function getHeadTypeList() {
    const headTypeList = [
        'Capital',
        'Revenue',
        'Rapier & Maintenance',
        'Loan',
        //'Non Eco'
    ];
    return headTypeList;
}

export function getAccountTypeList(forInfo = '') {

    let accountTypeList = [];

    if (forInfo == 'account') {
        //'Cash & Bank'
        accountTypeList = [
            'Petty Cash',
            'Project Account',
            'Operation Account'
        ];
    }
    else {
        //'Cash & Bank'
        accountTypeList = [
            'Assets',
            'Expenditure',
            'On Lending',
        ];
    }

    return accountTypeList;
}

export function getProjectComponentList() {
    const projectComponentList = [
        'TA',
        'On Lending',
    ];
    return projectComponentList;
}

export function getCategoryList() {
    const categoryList = [
        'Category 1',
        'Category 2',
    ];
    return categoryList;
}

export function getServiceTypeList() {
    const serviceTypeList = [
        'Loan'
    ];
    return serviceTypeList;
}

export function getEconomicUnit() {
    const Lists = [
        'LS',
        'Number',
        'Person',
        'SM'
    ];
    return Lists;
}

export function getBudgetingYearList() {
    const serviceTypeList = [
        '2017-2018',
        '2018-2019',
        '2019-2020',
        '2020-2021',
        '2021-2022',
        '2022-2023',
        '2023-2024',
        '2024-2025',
        '2025-2026',
        '2026-2027',
        '2027-2028',
        '2028-2029',
        '2029-2030',
    ];
    return serviceTypeList;
}

export function defaultUrl() {
    const defaultUrl = [
        '/dashboard',
        '/user',
        '/menu',
        '/project-info',
        '/financial',
        '/financial/bip-report/add-new',
        '/on-lending',
        '/project-info/operation-activities-form',
        '/user/permission',
        '/project-info/project-budget-detail',
        '/project-info/yearly-pro-budget-detail',
        '/on-lending/loan-profile-stepform',
        '/on-lending/disbursement',
        '/on-lending/re-payment',

    ];
    return defaultUrl;
}

/* ----------------validation rules-------------------
email: [
    v => !!v || "Field is required",
    v => /(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(v) || "Enter valied e-mail"
  ],
phone : [
    v => !!v || "Field is required",
    v => /^\d{10}$/.test(v) || "Enter valied e-mail"
]
  */


// WEBPACK FOOTER //
// ./src/utilities/utilities.js